import React, { useMemo } from "react";
import { BrowserRouter } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { AppShell } from "./shell/AppShell";
import { ThemeModeProvider, useThemeMode } from "./context/ThemeModeContext";
import { createAppTheme } from "./utils/theme.util";

function ThemedShell() {
  const { mode } = useThemeMode();
  const theme = useMemo(() => createAppTheme(mode), [mode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default function App() {
  return (
    <ThemeModeProvider>
      <ThemedShell />
    </ThemeModeProvider>
  );
}
